
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.016","height":"12.21"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_13800","data-name":"Group 13800","transform":"translate(-628.5 -351.784)","fill":"none","stroke":"#6b7786","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('line',{attrs:{"id":"Line_377","data-name":"Line 377","y2":"7.199","transform":"rotate(-135 390.457 50.662)"}}),_c('line',{attrs:{"id":"Line_378","data-name":"Line 378","x1":"7.147","transform":"rotate(-135 395.674 48.5)"}}),_c('line',{attrs:{"id":"Line_380","data-name":"Line 380","x1":"13.016","transform":"rotate(180 321.258 176.392)"}})])])
          )
        }
      }
    